import { cn } from '@sohanemon/utils';
import * as React from 'react';

export type FilterOption<T> = {
	value: T;
	label: string;
};

type FilterPillsProps<T> = Omit<
	React.ComponentPropsWithoutRef<'div'>,
	'onChange'
> & {
	prefix?: string;
	options: FilterOption<T>[];
	value: T;
	onChange: (value: T) => void;
};

export function FilterPills<T>({
	prefix,
	options,
	value,
	onChange,
	className,
	...props
}: FilterPillsProps<T>) {
	return (
		<div
			className={cn('flex flex-wrap items-center gap-1.5', className)}
			{...props}
		>
			{prefix && (
				<span className="me-1 font-mono text-2xs text-primary uppercase tracking-widest">
					{prefix}
				</span>
			)}
			{options.map((option) => {
				const isActive = value === option.value;
				return (
					<button
						key={option.label}
						type="button"
						onClick={() => onChange(option.value)}
						aria-pressed={isActive}
						className={cn(
							'rounded-full border px-3 py-1 font-mono text-2xs uppercase tracking-widest outline-none transition-colors duration-300 focus-visible:ring-2 focus-visible:ring-primary/70',
							isActive
								? 'border-transparent bg-primary font-medium text-primary-foreground'
								: 'border-primary/20 text-muted-foreground hover:border-primary/50 hover:text-primary',
						)}
					>
						{option.label}
					</button>
				);
			})}
		</div>
	);
}
